/* eslint-disable */
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Webcam from "react-webcam";
import profileadressinformation from "../../candidate_profile_creation/labels/adress_information_en.json";
import experienceinformation from "../../candidate_profile_creation/labels/experience_information_en.json";
import otherinformationLabel from "../../candidate_profile_creation/labels/other_information_en.json";
import profileDetailsLabel from "../../candidate_profile_creation/labels/personal_information_en.json";
import qualificationinformation from "../../candidate_profile_creation/labels/qualification_information_en.json";
import profileuploadphotosignature from '../../candidate_profile_creation/labels/upload_photo_and_signature_en.json';
import ModuleHide from "../../common/components/ModuleHide";
import {
  AUTHOR_TYPES,
  BOOLEAN_OPTION,
  FULLTIME_OPTION,
} from "../../common/constants/dropdownOptions";
import { dateDiffereceExServiceMan, getFormattedDate } from "../../helpers/Datetime";
import {
  articleType,
  authorType,
  flgPublicationFirstAuthor,
  getDropdownOptionLabel,
  getLookupOptionLabelNew,
  nameOfIndexingBodies,
} from "../../helpers/LookupOptionHelper";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/advertisement.css";
import "../../styles/advertisementTable.css";
const defaultImage =
  "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";

import { Button, Modal } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import qualificationinformation_hindi from "../../candidate_profile_creation/labels/qualification_information_hin.json";
import commonENLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import { dateDifference } from "../../helpers/Datetime";
import {
  downloadAdvertisementPdf
} from "../actions/advertisementAction";
import advertisementDetailsLabel from "../labels/advertisement_details_en.json";
import common from "../labels/common_en.json";
import QuestionDetails from "./QuestionDetails";



function getStateName(statecode, stateList) {
  const state =
    stateList && stateList.find((state) => state.code == statecode);
  if (!state) return statecode;
  return state.name;
}

function getDistrict(districtcode, districtList) {
  const district =
    districtList &&
    districtList.find((district) => district.code == districtcode);
  if (!district) return districtcode;
  return district.name;
}
function getTaluka(talukacode, talukaList) {
  const taluka =
    talukaList &&
    talukaList.find((taluka) => taluka.code == talukacode);
  if (!taluka) return talukacode;
  return taluka.name;
}
function getVillage(villagecode, villageList) {
  const village =
    villageList &&
    villageList.find((village) => village.code == villagecode);
  if (!village) return villagecode;
  return village.name;
}

function getQualificationType(qualificationTypecode, qualificationtypeList) {
  const qualification =
    qualificationtypeList &&
    qualificationtypeList.find(
      (qualification) =>
        qualification.qualificationtypecode == qualificationTypecode
    );

  if (!qualification) return qualificationTypecode;
  return qualification.qualificationtypename;
}

function getUniversity(universitycode, universityname) {
  const university =
    universityname &&
    universityname.find(
      (university) => university.universityCode == universitycode
    );
  if (!university) return universitycode;
  return university.universityName;
}

export function getSubject(subjectid, subjectname) {
  if (!subjectname || !Array.isArray(subjectname)) return "";
  if (typeof subjectid === "string" && subjectid.includes(",")) {
    const subjectIds = subjectid.split(",").map((id) => parseInt(id.trim(), 10));
    const matchedSubjects = subjectname
      .filter((subject) => subjectIds.includes(subject.subjectId))
      .sort((a, b) => subjectIds.indexOf(a.subjectId) - subjectIds.indexOf(b.subjectId));
    return matchedSubjects.map((subject) => subject.subjectName).join(", ");
  }

  const subject = subjectname.find((subject) => subject.subjectId == subjectid);
  if (!subject) return "";
  return subject.subjectName;
}

function getMobileMask(mobileno) {
  if (mobileno) {
    const mobilenumber = mobileno.toString();
    const maskMobileNumber = mobilenumber.replace(
      mobilenumber.substring(2, 8),
      "XXXXXX"
    );
    return maskMobileNumber;
  }
}
function getExServiceManDivision(exServiceManDivision) {
  let exServiceDivision;
  if (exServiceManDivision == "Air_Force") {
    exServiceDivision = "Air Force";
  } else if (exServiceManDivision == "Gallantry_Award_winners") {
    exServiceDivision = "Gallantry Award winners of Territorial Army";
  } else {
    exServiceDivision = exServiceManDivision;
  }
  return exServiceDivision;
}
const getEligibility = (eligibility) => {
  let list = [];
  eligibility.forEach((ele, index) => {
    if (ele && index === 0) {
      list.push("A");
    }
    if (ele && index === 1) {
      list.push("B");
    }
    if (ele && index === 2) {
      list.push("C");
    }
    if (ele && index === 3) {
      list.push("D");
    }
  });
  return list.toString();
};

function getQualificationNameCode(
  qualificationnamecode,
  qualificationnameList
) {
  const qualification =
    qualificationnameList &&
    qualificationnameList.find(
      (qualification) =>
        qualification.qualificationNameCode == qualificationnamecode
    );
  if (!qualification) return qualificationnamecode;
  return qualification.qualificationName;
}
const ProfileDetails = ({ allDeclAccepted, setAllDeclAccepted, SetIsCheckboxMarked, isCameraOn, setIsCameraOn, takePhoto, setShowName, showName, popupName, setShowSuccessLivePhotoModal, showSuccessLivePhotoModal, timer, hideModal, advertisementDetailsInfo, eligibilityResultList, applicationPostPrefList, applicableAdditionalQuestionsList, additionalAnswers, additionalAnswersState, handleQuestions, isNext, handlePrefChange, isCheckboxMarked, movePostPrefDown, movePostPrefUp, handleMenuClick, handleOptionsChange, formatGroupLabel, InputOption, someOptionsThisPost, showReviewDepartmentModal, doNext, selectedOptionErr, resetPref, uploadedDocumentData, handleDocChange, handleDocumentListShow, onChangeDocument, viewDocument, examCenterOptionList, isCenterSelection, maxCenterSelectionNumber, selectedExamCenters, setSelectedExamCenters, goBack, onApply, viewProfile, uploadLiveImage, ImageCropper, errorLivePhoto, webcamRef, capture, removeCandidateLiveImage, showLiveImageCropper, deptOptions, applicationFee, applicationFeeWithoutConcession }) => {
  const [location, setLocation] = useState("");
  const [arraymModule, setarraymModule] = useState({});
  let [showPublicationTable, setShowPublicationTable] = useState(false);
  let [showInternshipTable, setShowInternshipTable] = useState(false);
  const dispatch = useDispatch();

  const {
    profileCreationAllLookupData,
    qualificationTypes,
    nameOfIndexingBodiesList,
    getPublicationArticleTypeList,
    internshipList
  } = useSelector((state) => state.profile, shallowEqual);

  const { isApplicationLivePhotoEnable } = useSelector((state) => state.advertisement, shallowEqual)

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDownCus);
    return () => {
      window.removeEventListener('keydown', handleKeyDownCus);
    };
  }, []);

  const handleKeyDownCus = (event) => {
    // Prevent Windows+Shift+S (screenshot)
    if (event.key === 'S' && event.shiftKey && event.metaKey) {
      event.preventDefault();  // Prevent the screenshot tool from opening
    }
    // You can also prevent Ctrl+P and Ctrl+S if you want (optional)
    else if ((event.ctrlKey && event.key === 'p') || (event.ctrlKey && event.key === 's')) {
      event.preventDefault();  // Prevent print/save
    }
  };

  const { profileInfo, advertisementId } = useSelector(
    (state) => state.advertisement,
    shallowEqual
  );

  const { profileSummaryInfo } = useSelector((state) => state.myaccount, shallowEqual);
  let { showPreferences } = useSelector((state) => state.common, shallowEqual);


  const { moduleList } = useSelector(
    (state) => state.loginReducer,
    shallowEqual
  );

  let count = 0;
  let publilcationTableCount = 0;
  let validQuestionList;
  let internshipCount = 0;



  useEffect(() => {
    setarraymModule(
      moduleList &&
      moduleList.filter((ele) => ele.moduleName === "VIEW_PROFILE")[0]
    );
  }, [moduleList]);

  useEffect(() => {
    if (profileInfo && profileInfo.qualificationInfoList) {
      const hasPbQualification =
        profileInfo &&
        profileInfo.qualificationInfoList.some(
          (item) => item.qualificationtypecode === "Pb"
        );
      setShowPublicationTable(hasPbQualification);
      (profileInfo.intershipInfoList.length > 0 && setShowInternshipTable(true));

    }
  }, [profileInfo, internshipList]);

  if (profileInfo == null) {
    return <div className="ms-3">{profileDetailsLabel.PROFILE_NOT_LOADED}</div>;
  }
  
  const {
    requiredStates,
    requiredQualificationNameCode,
    requiredQualificationTypeCodes,
    requiredQualificationUniversityCodes,
    requiredSubject,
    requiredTaluka,
    requiredVillage,
    requiredDistricts,
  } = profileInfo;

  if (!profileInfo.personalInfoDto && profileInfo.personalInfo) {
    profileInfo.personalInfoDto = profileInfo.personalInfo;
  }
  const handleFromToDateSelection = (fromdate, todate) => {
    let expYears;
    let expMonths;
    let expDays;
    let difference = dateDiffereceExServiceMan(fromdate, todate);
    expYears = difference.years;
    expMonths = difference.months;
    expDays = difference.days;
    return (
      "Years" +
      " " +
      expYears +
      ", " +
      "Months   " +
      " " +
      expMonths +
      ", " +
      "Days" +
      " " +
      expDays
    );
  };
  const handleFromToDateSelectionForExp = (fromdate, todate) => {
    let expYears;
    let expMonths;
    let expDays;
    let difference = dateDiffereceExServiceMan(fromdate, todate);
    expYears = difference.years;
    expMonths = difference.months;
    expDays = difference.days;
    return {
      expYears: expYears,
      expMonths: expMonths,
      expDays: expDays,
    };
  };

  const getElibilityIndicator = (postCriteriaId) => {
    const isEligible = computeIsEligible(postCriteriaId);
    const message = computeIsEligibleMsg(postCriteriaId);
    const text = message && message.split("\n");
    if (isEligible == null) {
      return;
    }
    return isEligible ? (
      <span className="text-success">{advertisementDetailsLabel.YouAreEligiblePost}</span>
    ) : (
      <span className="text-danger">
        <p className="text-danger">
          {advertisementDetailsLabel.YouAreNotEligiblePost}
        </p>{" "}
        {text.map((ele, i) => (
          <p key={i} className="mb-n1">
            {ele}
          </p>
        ))}
      </span>
    );
  };

  const computeIsEligible = (postCriteriaId) => {
    const eligibilityResult = eligibilityResultList?.find(
      (elgbResult) => elgbResult.postCriteriaId == postCriteriaId
    );
    if (!eligibilityResult) {
      return null;
    }
    return eligibilityResult.isEligible;
  };

  const computeIsEligibleMsg = (postCriteriaId) => {
    const eligibilityResult = eligibilityResultList?.find(
      (elgbResult) => elgbResult.postCriteriaId == postCriteriaId
    );
    if (!eligibilityResult) {
      return null;
    }
    return eligibilityResult.message;
  };

  const downloadPdfFile = () => {
    dispatch(downloadAdvertisementPdf(advertisementId));
  };


  const getPostName = (postCriteriaId, isDvng) => {
    const examPost = advertisementDetailsInfo?.data?.examPostList?.find(
      (examPost) => examPost.postCriteria.id == postCriteriaId
    );
    if (!examPost) {
      return `Unknown (${postCriteriaId})`;
    }
    return isDvng ? examPost.postCriteria.nameDvng : examPost.postCriteria.name;
  };

  const handleApply = () => {
    if (!isCheckboxMarked) {
      toastr.error(commonENLabels.VALIDATE_MESSAGE.CHECKBOX_REQUIRED_ERR_MES);
      return;
    }

    // if (isApplicationLivePhotoEnable) {
    if (!allDeclAccepted) {
      toastr.error(commonENLabels.VALIDATE_MESSAGE.ACCEPT_ALL_DECLARATIONS_ERR_MES);
      return;
    }

    if (!location) {
      toastr.error(commonENLabels.VALIDATE_MESSAGE.LOCATION_ERR_MES);
      return;
    }

    if (
      (uploadLiveImage.showCandidatePhoto === "" || uploadLiveImage.showCandidatePhoto.length === 0) &&
      (uploadLiveImage.showCandidatePhotoBase64 === "" || uploadLiveImage.showCandidatePhotoBase64 === null) && isApplicationLivePhotoEnable
    ) {
      toastr.error(commonENLabels.VALIDATE_MESSAGE.UPLOAD_LIVE_IMAGE_ERR_MES);
      return;
    }

    if (!allAnswersFilled) {
      toastr.error(commonENLabels.VALIDATE_MESSAGE.ALL_REQUIRED_ANSWER_ERR_MES);
      return;
    }

    if (isCenterSelection && selectedExamCenters.length > maxCenterSelectionNumber) {
      toastr.error(commonENLabels.VALIDATE_MESSAGE.EXAM_CENTER_ERR_MES);
      return;
    }
    // }
    onApply(location, validQuestionList, isApplicationLivePhotoEnable);
  };

  const questionWithoutParent = applicableAdditionalQuestionsList && applicableAdditionalQuestionsList.length > 0 ? applicableAdditionalQuestionsList.filter((question) => !question.parentId) : []

  //--------------validate question list
  validQuestionList = applicableAdditionalQuestionsList && applicableAdditionalQuestionsList.length > 0
    ? applicableAdditionalQuestionsList.filter((que) => {
      if (que.parentId) {
        let isParentAnsValid = false;

        let getParentAnswerValid = applicableAdditionalQuestionsList.find(item => item.id === que.parentId);

        if (getParentAnswerValid) {
          let parentAnswer = additionalAnswers.find(item => item.id === getParentAnswerValid.id);

          if (parentAnswer && parentAnswer.answer) {
            let answerValue = parentAnswer.answer;


            switch (que.parentValidation.comparison) {
              case "Equals":
                isParentAnsValid = answerValue == que.parentValidation.value || (answerValue).toString() == (que.parentValidation.value).toString()
                break;
              case "NotEquals":
                isParentAnsValid = answerValue != que.parentValidation.value && (answerValue).toString() != (que.parentValidation.value).toString()
                break;
              case "In":
                const valuesToCheck = Array.isArray(que.parentValidation.values) ? que.parentValidation.values : [que.parentValidation.values];
                isParentAnsValid = Array.isArray(answerValue) ? answerValue.some(val => valuesToCheck.includes(val)) : valuesToCheck.includes(answerValue);
                break;
              case "NotIn":
                const notInValues = Array.isArray(answerValue) ? answerValue : [answerValue];
                isParentAnsValid = !notInValues.some(val => que.parentValidation.values.includes(val));
                break;
              case "Contains":
                isParentAnsValid = String(answerValue).includes(String(que.parentValidation.value));
                break;
              case "Between":
                isParentAnsValid = parseInt(answerValue) >= parseInt(que.parentValidation.minValue) && parseInt(answerValue) <= parseInt(que.parentValidation.maxValue);
                break;
              case "GreaterThan":
                isParentAnsValid = parseInt(answerValue) > parseInt(que.parentValidation.minValue);
                break;
              case "LessThan":
                isParentAnsValid = parseInt(answerValue) < parseInt(que.parentValidation.minValue);
                break;
              case "GreaterThanEqualTo":
                isParentAnsValid = parseInt(answerValue) >= parseInt(que.parentValidation.minValue);
                break;
              case "LessThanEqualTo":
                isParentAnsValid = parseInt(answerValue) <= parseInt(que.parentValidation.minValue);
                break;
              default:
                isParentAnsValid = false;
            }
          }
        }
        return isParentAnsValid;
      }

      return true;
    })
    : false;

  //--------------validate question list

  const allAnswersFilled = validQuestionList && validQuestionList.length > 0 ? validQuestionList.every(question => {
    if (!question.validation) return true;
    const answer = additionalAnswers.find(a => a.id === question.id);

    return answer &&
      answer.answer !== undefined &&
      answer.answer !== null &&
      (Array.isArray(answer.answer) ? answer.answer.length > 0 : answer.answer !== "");
  }) : true;

  const exServicemanFromDate = profileInfo && profileInfo.personalInfoDto && profileInfo.personalInfoDto.dateDischargeArmedRegular;
  const exServicemanToDate = profileInfo && profileInfo.personalInfoDto && profileInfo.personalInfoDto.exServiceManToDate;
  const exServicemanDateDifference = dateDifference(exServicemanFromDate, exServicemanToDate);

  const nccFromDate = profileInfo && profileInfo.personalInfoDto && profileInfo.personalInfoDto.ncccIssuingDate;
  const nccToDate = profileInfo && profileInfo.personalInfoDto && profileInfo.personalInfoDto.nccToDate;
  const nccDateDifference = dateDifference(nccFromDate, nccToDate);

    const hasAtLeastOneInterested = applicationPostPrefList &&
    applicationPostPrefList.length > 0 &&
    applicationPostPrefList.some(item => item.isInterested === true);
    


  return arraymModule && arraymModule.isEnabled == false ? (
    <ModuleHide details={arraymModule} />
  ) : (
    <div>
      {(eligibilityResultList != null || viewProfile) &&
        <div id="profileDetails-container ">
          <div className="advertisement_details_Eligibility border border-light pt-0">
            <div className="box-contents tab_container_box">
              {viewProfile ?
                <h6>
                  {commonENLabels.MY_ACCOUNT.VIEW_PROFILE}
                </h6>
                :
                <h6>
                  {commonENLabels.NEW_APPLICATION.APPLICATION_PROFORMA} :{" "}
                  {commonHILabels.NEW_APPLICATION.APPLICATION_PROFORMA}
                </h6>
              }
              <div className="my-2 full-width-bottom-blue-border"></div>

              <div className="box-contents">
                <div className="row">
                  <div className="col-md-2">
                    <img
                      className="img-profile border"
                      src={`data:image/png;base64,${profileInfo.livephoto && profileInfo.livephoto !== null
                        ? profileInfo.livephoto
                        : defaultImage
                        }`}
                      width="130"
                      height="auto"
                    />
                  </div>
                  <div className="col-md-10">
                    <div className="row">
                      <div className="col-md-5 pad_0">
                        <div className="content-row">
                          <h6>{profileDetailsLabel.FULLNAME_ENGLISH}</h6>
                          <span className="word-break">
                            {profileInfo.personalInfoDto.englishFullName}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4 pad_0">
                        <div className="content-row">
                          <h6>{profileDetailsLabel.FULLNAME_HINDI}</h6>
                          <span>{profileInfo.personalInfoDto.devnagariFullName}</span>
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div className="row">
                      <div className="col-md-5 pad_0">
                        <div className="content-row">
                          <h6> {profileDetailsLabel.Email_ID} </h6>
                          <span>
                            {profileInfo.personalInfoDto.emailId
                              ? profileInfo.personalInfoDto.emailId
                              : ""}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4 pad_0">
                        <div className="content-row">
                          <h6>{profileDetailsLabel.MOBILE_NO}</h6>
                          <span>
                            {profileInfo.personalInfoDto.mobileNumber}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 pad_0">
                        <hr className="mar_top_bottom_8" />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5 pad_0">
                        <div className="content-row">
                          <h6>{profileDetailsLabel.DATE_OF_BIRTH}</h6>
                          <span>
                            {profileInfo.personalInfoDto.dob
                              ? dayjs(
                                getFormattedDate(
                                  new Date(profileInfo.personalInfoDto.dob)
                                )
                              ).format(commonLabels.DATE_FORMAT)
                              : ""}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4 pad_0">
                        <div className="content-row">
                          <h6>{profileDetailsLabel.MOTHERS_NAME}</h6>
                          <span>{profileInfo.personalInfoDto.motherName}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 pad_0">
                        <hr className="mar_top_bottom_8" />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5 pad_0">
                        <div className="content-row">
                          <h6>{profileDetailsLabel.FATHERS_NAME}</h6>
                          <span>{profileInfo.personalInfoDto.fatherName}</span>
                        </div>
                      </div>
                      <div className="col-md-4 pad_0">
                        <div className="content-row">
                          <h6> {profileDetailsLabel.GENDER} </h6>
                          <span>
                            {getLookupOptionLabelNew(
                              profileInfo.personalInfoDto.genderLookupId,
                              profileCreationAllLookupData
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 pad_0">
                        <hr className="mar_top_bottom_8" />
                      </div>
                      <div className="col-md-5 pad_0">
                        <div className="content-row">
                          <h6>{profileDetailsLabel.WHETHER_MARRIED}</h6>
                          <span>
                            {getLookupOptionLabelNew(
                              profileInfo.personalInfoDto.maritalStatusLookupId,
                              profileCreationAllLookupData
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4 pad_0">
                        <div className="content-row">
                          <h6>{(profileInfo.personalInfoDto.idTypeLookupId === commonENLabels.DATABASE_VALUES.AADHAR_CARD_LOOKUP_ID) ? commonENLabels.SIGN_UP.AADHAR_NO_PLACEHOLDER : (profileInfo.personalInfoDto.idTypeLookupId === commonENLabels.DATABASE_VALUES.PAN_CARD_LOOKUP_ID) ? commonENLabels.SIGN_UP.PAN_CARD_NO_PLACEHOLDER : (profileInfo.personalInfoDto.idTypeLookupId === commonENLabels.DATABASE_VALUES.DL_LOOKUP_ID) ? commonENLabels.SIGN_UP.DRIVING_LI_NO_PLACEHOLDER : ''}</h6>
                          {(profileInfo.personalInfoDto.idTypeLookupId === commonENLabels.DATABASE_VALUES.AADHAR_CARD_LOOKUP_ID) ?
                            <span>
                              {
                                profileInfo.personalInfoDto.idNumber
                                  ? "XXXX-XXXX-" +
                                  profileInfo.personalInfoDto.idNumber.slice(-4)
                                  : ""
                              }
                            </span>
                            :
                            (profileInfo.personalInfoDto.idTypeLookupId === commonENLabels.DATABASE_VALUES.PAN_CARD_LOOKUP_ID) ?
                              <span>
                                {
                                  profileInfo.personalInfoDto.idNumber
                                    ? "XXXXX" + profileInfo.personalInfoDto.idNumber.slice(-4)
                                    : ""
                                }
                              </span>
                              :
                              (profileInfo.personalInfoDto.idTypeLookupId === commonENLabels.DATABASE_VALUES.DL_LOOKUP_ID) ?
                                <span>
                                  {
                                    profileInfo.personalInfoDto.idNumber
                                      ? "XXXX-XXXX-" + profileInfo.personalInfoDto.idNumber.slice(-4)
                                      : ""
                                  }
                                </span>
                                : ""
                          }
                        </div>
                      </div>
                      { profileInfo.personalInfoDto.genderLookupId == 329 && profileInfo.personalInfoDto.maritalStatusLookupId == 365 && <div className="col-md-4 pad_0">
                        <div className="content-row">
                          <h6>{profileDetailsLabel.HUSBAND_NAME}</h6>
                          <span>
                             {profileInfo.personalInfoDto.husbandName}
                          </span>
                        </div>
                     </div>}
                    </div>
                    <div className="col-md-12 pad_0">
                      <hr className="mar_top_bottom_8" />
                    </div>
                    {(profileInfo.personalInfoDto.changedEnglishName || profileInfo.personalInfoDto.identificationMark) &&
                      <div className="row">
                        <div className="col-md-5 pad_0">
                          <div className="content-row">
                            <h6>{profileDetailsLabel.CHANGED_NAME}</h6>
                            <span className="word-break">
                              {profileInfo.personalInfoDto.changedEnglishName ? profileInfo.personalInfoDto.changedEnglishName : "-"}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-5 pad_0">
                          <div className="content-row">
                            <h6>{commonENLabels.PERSONAL_INFORMATION.IDENTIFICATION_MARK}</h6>
                            <span className="word-break">
                              {profileInfo.personalInfoDto.identificationMark}
                            </span>
                          </div>
                        </div>

                      </div>
                    }

                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 pad_0">
                  <hr className="mar_top_bottom_8" />
                </div>
              </div>

              {/* Personal Details */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0">
                    {profileDetailsLabel.SECOND_PROFILE_HEADER}{commonHILabels.PERSONAL_INFORMATION.PERSONAL_DETAILS}
                  </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="content-row clear-fix">
                        <h6>{commonENLabels.PERSONAL_INFORMATION.ARE_YOU_CITIZEN_OF_INDIA}{commonHILabels.PERSONAL_INFORMATION.ARE_YOU_CITIZEN_OF_INDIA}</h6>
                        <span>
                          {profileInfo.personalInfo.nationalityLookupId ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="content-row clear-fix">
                        <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_15}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_15}</h6>
                        <span>
                          {profileInfo.personalInfo.isDomicile ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {(profileInfo.personalInfo.nationalityLookupId || profileInfo.personalInfo.isDomicile) && (
                    <div>
                      <hr className="mt-1 mb-0" />
                      <div className="d-flex p-2">
                        <div className="col-md-6 d-flex gap-2 align-items-center">
                          <h6 className="m-0">
                            {commonENLabels.PERSONAL_INFORMATION.RESIDENCE_CERTIFICATE_NO} {commonHILabels.PERSONAL_INFORMATION.RESIDENCE_CERTIFICATE_NO} :
                          </h6>
                          <span>{profileInfo.personalInfo.domicileCertificateNo ? profileInfo.personalInfo.domicileCertificateNo : "N/A"}</span>
                        </div>
                        <div className="col-md-6 col-md-6 d-flex gap-2 align-items-center">
                          <h6 className="m-0">
                            {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_2} {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_2} :
                          </h6>
                          {profileInfo.personalInfoDto.domicileIssuingDate ? <span>{dayjs(getFormattedDate(new Date(profileInfo.personalInfoDto.domicileIssuingDate))).format(commonLabels.DATE_FORMAT)}</span> : "N/A"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Physical Measurement */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0">
                    {profileDetailsLabel.PHYSICAL_MESUREMENT}{commonHILabels.PERSONAL_INFORMATION.PHYSICAL_MESUREMENT}
                  </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="content-row clear-fix">
                        <h6>{profileDetailsLabel.HEIGHT}{commonHILabels.PERSONAL_INFORMATION.HEIGHT} : </h6>
                        <span>
                          {profileInfo.personalInfoDto.height ? profileInfo.personalInfoDto.height : "-"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="content-row clear-fix">
                        <h6>{profileDetailsLabel.WEIGHT}{commonHILabels.PERSONAL_INFORMATION.WEIGHT} : </h6>
                        <span>
                          {profileInfo.personalInfoDto.weight ? profileInfo.personalInfoDto.weight : "-"}
                        </span>
                      </div>
                    </div>
                    {(profileInfo.personalInfoDto.genderLookupId !== 329) &&
                      <hr className="mt-1 mb-0" />
                    }
                    {((profileInfo.personalInfoDto.genderLookupId !== 329)) ?
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>
                            {profileDetailsLabel.CHEST_DEFLATED}{commonHILabels.PERSONAL_INFORMATION.CHEST_DEFLATED} :
                          </h6>
                          <span>
                            {profileInfo.personalInfoDto.chestDeflated ? profileInfo.personalInfoDto.chestDeflated : '-'}
                          </span>
                        </div>
                      </div> : ""
                    }
                    {((profileInfo.personalInfoDto.genderLookupId !== 329)) ?
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>
                            {profileDetailsLabel.CHEST_INFLATED}{commonHILabels.PERSONAL_INFORMATION.CHEST_INFLATED} :
                          </h6>
                          <span>
                            {profileInfo.personalInfoDto.chestInflated ? profileInfo.personalInfoDto.chestInflated : '-'}
                          </span>
                        </div>
                      </div>
                      : ""}
                  </div>
                </div>
              </div>

              {/* caste details */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0">
                    {profileDetailsLabel.CASTE_CATEGORY_DETAILS}{commonHILabels.PERSONAL_INFORMATION.CASTE_CATEGORY_DETAILS}
                  </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="content-row clear-fix">
                        <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_18}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_18}</h6>
                        <span>
                          {profileInfo.personalInfo.isReservedCategory ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {(profileInfo.personalInfo.isReservedCategory) ?
                    <div className="row">
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>{profileDetailsLabel.CATEGORY}{commonHILabels.PERSONAL_INFORMATION.CATEGORY}: </h6>
                          <span>
                            {getLookupOptionLabelNew(
                              profileInfo.personalInfoDto
                                .categoryLookupId,
                              profileCreationAllLookupData
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.CASTE_NAME}{commonHILabels.PERSONAL_INFORMATION.CASTE_NAME} : </h6>
                          <span>
                            {getLookupOptionLabelNew(
                              profileInfo.personalInfoDto
                                .castenameLookupId,
                              profileCreationAllLookupData
                            )}
                          </span>
                        </div>
                      </div>
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          {((profileInfo.personalInfoDto.categoryLookupId == commonENLabels.DATABASE_VALUES.BC_CATEGORY_LOOKUP_ID) || (profileInfo.personalInfoDto.categoryLookupId == commonENLabels.DATABASE_VALUES.EBC_CATEGORY_LOOKUP_ID)) ?
                            <h6>
                              {commonENLabels.PERSONAL_INFORMATION.NCLC_CERTIFICATE_NO}{commonHILabels.PERSONAL_INFORMATION.NCLC_CERTIFICATE_NO} :
                            </h6>
                            :
                            (profileInfo.personalInfoDto.categoryLookupId == commonENLabels.DATABASE_VALUES.EWS_CATEGORY_LOOKUP_ID) ?
                              <h6>
                                {commonENLabels.PERSONAL_INFORMATION.EWS_CERTIFICATE_NO}{commonHILabels.PERSONAL_INFORMATION.EWS_CERTIFICATE_NO} :
                              </h6>
                              :
                              <h6>
                                {commonENLabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_NO}{commonHILabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_NO} :
                              </h6>
                          }
                          <span>
                            {
                              profileInfo.personalInfoDto
                                .casteCertificateNo
                            }
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_2}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_2} : </h6>
                          <span>
                            {profileInfo.personalInfoDto
                              .ccIssuingDate
                              ? dayjs(getFormattedDate(new Date(profileInfo.personalInfoDto.ccIssuingDate))).format(commonLabels.DATE_FORMAT)
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    :
                    <div className="row">
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>{profileDetailsLabel.CATEGORY}{commonHILabels.PERSONAL_INFORMATION.CATEGORY} : </h6>
                          <span>
                            {commonENLabels.PERSONAL_INFORMATION.UNRESERVED}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                  {((profileInfo.personalInfo.isReservedCategory === "No" && (profileInfo.personalInfoDto.genderLookupId === commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID)) || (profileInfo.personalInfo.isReservedCategory === "Yes")) &&
                    <div className="row">
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_21}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_21} : </h6>
                          <span>
                            {profileInfo.personalInfo.isCcIssuedByBihar ? "CO/RO" : "SDM/DM"}
                          </span>
                        </div>
                      </div>
                    </div>}
                </div>
              </div>

              {/* Freedom Fighter details */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0">
                    {commonENLabels.PERSONAL_INFORMATION.FREEDOM_FIGHTER_DETAILS}{commonHILabels.PERSONAL_INFORMATION.FREEDOM_FIGHTER_DETAILS}
                  </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="content-row clear-fix">
                        <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_22}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_22}</h6>
                        <span>
                          {profileInfo.personalInfo.isFfGrandchild ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {(profileInfo.personalInfo.isFfGrandchild) &&
                    <div className="row">
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>
                            {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_1}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_1} :
                          </h6>
                          <span>
                            {
                              profileInfo?.personalInfoDto
                                ?.ffcNumber
                            }
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_2}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_2} : </h6>
                          <span>
                            {profileInfo?.personalInfoDto
                              ?.ffcIssuingDate
                              ? dayjs(getFormattedDate(new Date(profileInfo?.personalInfoDto?.ffcIssuingDate))).format(commonLabels.DATE_FORMAT)
                              : "NA"}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

              {/* Persons with Disabilities Details */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0">
                    {profileDetailsLabel.Divyang_Details}{commonHILabels.PERSONAL_INFORMATION.DISABILITY_DETAILS}
                  </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row align-items-center">
                        <div className="col-md-10">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_24}</h6>
                          <h6>{commonHILabels.PERSONAL_INFORMATION.NOTE_1_24}</h6>
                        </div>
                        <div className="col-md-2">
                          <span>{profileInfo.personalInfo.isDivyang ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row align-items-center">
                        <div className="col-md-10">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.DO_YOU_REQUIRE_SCRIBE_DUE_TO_PERSON_WITH_DISABILITY}</h6>
                          <h6>{commonHILabels.PERSONAL_INFORMATION.DO_YOU_REQUIRE_SCRIBE_DUE_TO_PERSON_WITH_DISABILITY_hin}</h6>
                        </div>
                        <div className="col-md-2">
                          <span>{profileInfo.personalInfo.isDisabilityScribeReq ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {(profileInfo.personalInfo.isDivyang) &&
                    <div className="row">
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-12">
                        <div className="content-row clear-fix">
                          <h6>
                            {commonENLabels.PERSONAL_INFORMATION.NOTE_1_24_1}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_24_1}
                          </h6>
                          <span>
                            {getLookupOptionLabelNew(
                              profileInfo.personalInfoDto
                                .typeOfDisabilityLookupId,
                              profileCreationAllLookupData
                            )}
                          </span>
                        </div>
                      </div>
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              profileDetailsLabel.CASTE_CERTIFICATE_NUMBER
                            }{commonHILabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_NO} :
                          </h6>
                          <span>
                            {
                              profileInfo.personalInfoDto
                                .sadmCertificateNumber
                            }
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_2}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_2} : </h6>
                          <span>
                            {profileInfo.personalInfoDto
                              .sadmCertificateDate
                              ? dayjs(getFormattedDate(new Date(profileInfo.personalInfoDto.sadmCertificateDate))).format(commonLabels.DATE_FORMAT)
                              : ""}
                          </span>
                        </div>
                      </div>
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.DISABILITY_PERCENTAGE}{commonHILabels.PERSONAL_INFORMATION.DISABILITY_PERCENTAGE} : </h6>
                          <span>
                            {/* {profileInfo.personalInfoDto.divyangPercentage ? profileInfo.personalInfoDto.divyangPercentage : ""} */}
                            {getLookupOptionLabelNew(
                              profileInfo.personalInfoDto.divyangPercentage,
                              profileCreationAllLookupData
                            )}
                          </span>
                        </div>
                      </div>
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-12">
                        <div className="content-row clear-fix">
                          <h6>
                            {commonENLabels.PERSONAL_INFORMATION.GOV_CLG_DETAILS}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_26} :
                          </h6>
                          <span>
                            {getLookupOptionLabelNew(
                              profileInfo.personalInfoDto
                                .dbcIssuingInstituteLookupId,
                              profileCreationAllLookupData
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

              {/* sports details */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0"> {profileDetailsLabel.Sports_Details}{commonHILabels.PERSONAL_INFORMATION.SPORTS_DETAILS} </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="col-md-12">
                    <div className="content-row clear-fix">
                      <h6>
                        {otherinformationLabel["ARE_YOU _MERITORIOUS_SPORTS_PERSON?"]}{commonHILabels.PERSONAL_INFORMATION.SPORT_PERSON_NOTE}
                      </h6>
                      <span>
                        {profileInfo.personalInfoDto
                          .isMetritoriousSportsman
                          ? "Yes"
                          : "No"}
                      </span>
                    </div>
                  </div>
                </div>
                {/* {profileInfo.personalInfoDto.isMetritoriousSportsman ?
                  <div className="qualification-table qualificationTableCss">
                    <table className="table table-bordered" >
                      <thead>
                        <tr>
                          {sportsInformationLable.sportsHeaderContent && sportsInformationLable.sportsHeaderContent.slice(0, -1).map((ele, index) =>
                            <th scope="col" key={index} className="theadBgColor blue_box">{ele}</th>
                          )}
                        </tr>
                      </thead>
                      <tbody className="f12">
                        {profileInfo.personalInfoDto && profileInfo.personalInfoDto.meritoriousSportsmanDtoList.map((ele, index) => {
                          if (ele) {
                            return (
                              <tr key={index}>
                                <td className="w-10 word-break text-center">{index + 1}</td>
                                <td className="word-break">{getLookupOptionLabelNew(ele.typeOfCompetitionLookupId, profileCreationAllLookupData)}</td>
                                <td className="word-break">{getLookupOptionLabelNew(ele.nameOfCompetitionLookupId, profileCreationAllLookupData)}</td>
                                <td className="word-break">{getLookupOptionLabelNew(ele.positionMedalLookupId, profileCreationAllLookupData)}</td>
                                <td className="word-break">{ele.tournamentStartDate ? dayjs(getFormattedDate(new Date(ele.tournamentStartDate))).format(commonLabels.DATE_FORMAT) : ""}</td>
                                <td className="word-break">{ele.tournamentEndDate ? dayjs(getFormattedDate(new Date(ele.tournamentEndDate))).format(commonLabels.DATE_FORMAT) : ""}</td>
                                <td className="word-break">{ele.certificateVerificationStatus === true ? "Yes" : "No"}</td>
                                <td className="word-break">{getLookupOptionLabelNew(ele.sportsCertiVerificationCityId, profileCreationAllLookupData)}</td>
                                <td className="word-break">{ele.sportsCertiReportNo}</td>
                                <td className="word-break">{ele.dateOfIssue ? dayjs(getFormattedDate(new Date(ele.dateOfIssue))).format(commonLabels.DATE_FORMAT) : ""}</td>
                                <td className="word-break">{ele.acknowledgementNumber ? ele.acknowledgementNumber : '-'}</td>
                                <td className="word-break">{ele.dateOfSubmission ? dayjs(getFormattedDate(new Date(ele.dateOfSubmission))).format(commonLabels.DATE_FORMAT) : "-"}</td>
                                <td className="word-break">{getEligibility(ele.eligibleForGroup)}</td>
                              </tr>
                            )
                          }
                        })
                        }
                      </tbody>
                    </table>
                  </div> : ""} */}
              </div>

              {/* Ex-serviceman details */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0">
                    {commonENLabels.PERSONAL_INFORMATION.EX_SERVICEMAN_DETAILS}{commonHILabels.PERSONAL_INFORMATION.EX_SERVICEMAN_DETAILS}
                  </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="content-row clear-fix">
                        <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_38}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_38}</h6>
                        <span>
                          {profileInfo.personalInfo.isExArmedReg ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {(profileInfo.personalInfo.isExArmedReg) &&
                    <div className="row">
                      <hr className="mt-1 mb-0" />
                      <div className={viewProfile ? "col-md-4" : "col-md-3"}>
                        <div className="content-row clear-fix">
                          <h6>
                            {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_1}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_1} :
                          </h6>
                          <span>
                            {
                              profileInfo.personalInfoDto
                                .dischargeCertificateNo
                            }
                          </span>
                        </div>
                      </div>
                      <div className={viewProfile ? "col-md-4" : "col-md-3"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_FROM_DATE}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_FROM_DATE} : </h6>
                          <span>
                            {profileInfo.personalInfoDto
                              .dateDischargeArmedRegular
                              ? dayjs(getFormattedDate(new Date(profileInfo.personalInfoDto.dateDischargeArmedRegular))).format(commonLabels.DATE_FORMAT)
                              : ""}
                          </span>
                        </div>
                      </div>
                      <div className={viewProfile ? "col-md-4" : "col-md-3"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_TO_DATE}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_TO_DATE} : </h6>
                          <span>
                            {profileInfo.personalInfoDto
                              .exServiceManToDate
                              ? dayjs(getFormattedDate(new Date(profileInfo.personalInfoDto.exServiceManToDate))).format(commonLabels.DATE_FORMAT)
                              : ""}
                          </span>
                        </div>
                      </div>
                      {viewProfile && <hr className="mt-1 mb-0" />}
                      <div className={viewProfile ? "col-md-4" : "col-md-1"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.COMMON.YEARS} : </h6>
                          <span>
                            {exServicemanDateDifference && exServicemanDateDifference.years}
                          </span>
                        </div>
                      </div>
                      <div className={viewProfile ? "col-md-4" : "col-md-1"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.COMMON.MONTHS} : </h6>
                          <span>
                            {exServicemanDateDifference && exServicemanDateDifference.months}
                          </span>
                        </div>
                      </div>
                      <div className={viewProfile ? "col-md-4" : "col-md-1"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.COMMON.DAYS} : </h6>
                          <span>
                            {exServicemanDateDifference && exServicemanDateDifference.days}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

              {/* N.C.C Cadet details */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0">
                    {commonENLabels.PERSONAL_INFORMATION.N_C_C_CADET_DETAILS}{commonHILabels.PERSONAL_INFORMATION.NCC_CADET}
                  </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="content-row clear-fix">
                        <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_40}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_40}</h6>
                        <span>
                          {profileInfo.personalInfo.isNccCadet ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {(profileInfo.personalInfo.isNccCadet) &&
                    <div className="row">
                      <hr className="mt-1 mb-0" />
                      <div className={viewProfile ? "col-md-4" : "col-md-3"}>
                        <div className="content-row clear-fix">
                          <h6>
                            {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_1}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_1} :
                          </h6>
                          <span>
                            {
                              profileInfo.personalInfoDto
                                .nccCertificateNo
                            }
                          </span>
                        </div>
                      </div>
                      <div className={viewProfile ? "col-md-4" : "col-md-3"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_FROM_DATE}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_FROM_DATE} : </h6>
                          <span>
                            {profileInfo.personalInfoDto
                              .ncccIssuingDate
                              ? dayjs(getFormattedDate(new Date(profileInfo.personalInfoDto.ncccIssuingDate))).format(commonLabels.DATE_FORMAT)
                              : ""}
                          </span>
                        </div>
                      </div>
                      <div className={viewProfile ? "col-md-4" : "col-md-3"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_TO_DATE}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_TO_DATE} : </h6>
                          <span>
                            {profileInfo.personalInfoDto
                              .nccToDate
                              ? dayjs(getFormattedDate(new Date(profileInfo.personalInfoDto.nccToDate))).format(commonLabels.DATE_FORMAT)
                              : ""}
                          </span>
                        </div>
                      </div>
                      {viewProfile && <hr className="mt-1 mb-0" />}
                      <div className={viewProfile ? "col-md-4" : "col-md-1"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.COMMON.YEARS} : </h6>
                          <span>
                            {nccDateDifference && nccDateDifference.years}
                          </span>
                        </div>
                      </div>
                      <div className={viewProfile ? "col-md-4" : "col-md-1"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.COMMON.MONTHS} : </h6>
                          <span>
                            {nccDateDifference && nccDateDifference.months}
                          </span>
                        </div>
                      </div>
                      <div className={viewProfile ? "col-md-4" : "col-md-1"}>
                        <div className="content-row clear-fix">
                          <h6>{commonENLabels.COMMON.DAYS} : </h6>
                          <span>
                            {nccDateDifference && nccDateDifference.days}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

              {/* Government Employee Details */}
              <div className="card mb-2">
                <div className="card-header">
                  <h6 className="mb-0">
                    {commonENLabels.PERSONAL_INFORMATION.GOVERNMENT_EMPLOYEE_DETAILS}
                    {commonHILabels.PERSONAL_INFORMATION.GOVT_EMP}
                  </h6>
                </div>
                <div className="card-body pad_top_bottom_8">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="content-row clear-fix">
                        <h6>{commonENLabels.PERSONAL_INFORMATION.NOTE_1_42}{commonHILabels.PERSONAL_INFORMATION.NOTE_1_42}</h6>
                        <span>
                          {profileInfo.personalInfo.isGobEmployee ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {(profileInfo.personalInfo.isGobEmployee) &&
                    <div className="row">
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>
                            {commonENLabels.PERSONAL_INFORMATION.DESIGNATION}{commonHILabels.PERSONAL_INFORMATION.DESIGNATION} :
                          </h6>
                          <span>
                            {getLookupOptionLabelNew(
                              profileInfo.personalInfoDto
                                .jobDesignation,
                              profileCreationAllLookupData
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>
                            {commonENLabels.PERSONAL_INFORMATION.OFFICE}{commonHILabels.PERSONAL_INFORMATION.OFFICE} :
                          </h6>
                          <span>
                            {profileInfo.personalInfoDto
                              .jobOffice}
                          </span>
                        </div>
                      </div>
                      <hr className="mt-1 mb-0" />
                      <div className="col-md-6">
                        <div className="content-row clear-fix">
                          <h6>
                            {commonENLabels.PERSONAL_INFORMATION.PLACE}{commonHILabels.PERSONAL_INFORMATION.PLACE} :
                          </h6>
                          <span>
                            {profileInfo.personalInfoDto
                              .jobPlace}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>



              <h6 className="mt-1">
                {commonENLabels.NEW_APPLICATION.ADD_INFO}:{" "}
                {commonHILabels.ADDRESS_INFORMATION.ADDRESS_INFORMATION}
              </h6>
              <div className="my-2 full-width-bottom-blue-border"></div>

              <div className="row">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header blue_box pb-1 pt-1">
                      <span>{profileadressinformation.PERMENANT_ADDRESS}{commonHILabels.ADDRESS_INFORMATION.PERMANENT_ADDRESS}</span>
                    </div>
                    <div className="card-body pad_top_bottom_8">
                      <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.ADDRESS_LINE_1}</h6>
                        <span className="word-break">
                          {profileInfo.addressInfo.permenantAddressLine1}
                        </span>
                      </div>
                      <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.ADDRESS_LINE_2}</h6>
                        <span className="word-break">
                          {profileInfo.addressInfo.permenantAddressLine2}
                        </span>
                      </div>
                      <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.ADDRESS_LINE_3}</h6>
                        <span className="word-break">
                          {profileInfo.addressInfo.permenantAddressLine3}
                        </span>
                      </div>
                      {/* <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.VILLAGE_CITY}</h6>
                        {profileInfo.addressInfo &&
                          profileInfo.addressInfo.permenantVillageCityId ? (
                          <span className="word-break">
                            {getVillage(
                              profileInfo.addressInfo
                                .permenantVillageCityId,
                              requiredVillage
                            )}
                          </span>
                        ) : (
                          <span className="word-break">
                            {profileInfo.addressInfo.permenantVillageCity}
                          </span>
                        )}
                      </div> */}

                      {/* <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.TALUKA}</h6>
                        {profileInfo.addressInfo &&
                          profileInfo.addressInfo.permenantTalukaId ? (
                          <span className="word-break">
                            {getTaluka(
                              profileInfo.addressInfo.permenantTalukaId,
                              requiredTaluka
                            )}
                          </span>
                        ) : (
                          <span className="word-break">
                            {profileInfo.addressInfo.permenantTaluka}
                          </span>
                        )}
                      </div> */}
                      <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.DISTRICT}</h6>
                        {profileInfo.addressInfo &&
                          profileInfo.addressInfo.permenantDistrictId ? (
                          <span className="word-break">
                            {getDistrict(
                              profileInfo.addressInfo.permenantDistrictId,
                              requiredDistricts
                            )}
                          </span>
                        ) : (
                          <span className="word-break">
                            {profileInfo.addressInfo.permenantDistrict}
                          </span>
                        )}
                      </div>
                      <div className="content-row clear-fix pb-1 pt-0">
                        <div className="row">
                          <div className="col-md-8">
                            <h6>{profileadressinformation.STATE_UNION_TERRITORY}</h6>
                            <span>
                              {getStateName(
                                profileInfo.addressInfo.permenantStateId,
                                requiredStates
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="content-row clear-fix pb-1 pt-0">
                        <div className="col-md-4">
                          <h6>{profileadressinformation.PINCODE}</h6>
                          <span>{profileInfo.addressInfo.permenantPin}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header blue_box pb-1 pt-1">
                      <span>
                        {profileadressinformation.CORRESPONDANCE_ADDRESS}{commonHILabels.ADDRESS_INFORMATION.CORRESPONDANCE_ADDRESS}
                      </span>
                    </div>
                    <div className="card-body pad_top_bottom_8">
                      <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.ADDRESS_LINE_1}</h6>
                        <span className="word-break">
                          {profileInfo.addressInfo.correspondenceAddressLine1}
                        </span>
                      </div>
                      <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.ADDRESS_LINE_2}</h6>
                        <span className="word-break">
                          {profileInfo.addressInfo.correspondenceAddressLine2}
                        </span>
                      </div>
                      <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.ADDRESS_LINE_3}</h6>
                        <span className="word-break">
                          {profileInfo.addressInfo.correspondenceAddressLine3}
                        </span>
                      </div>
                      {/* <div className="content-row clear-fix">
                      <h6>{profileadressinformation.LANDMARK}</h6>
                      <span className="word-break">
                        {profileInfo.addressInfo.correspondenceLandmark}
                      </span>
                    </div> */}
                      {/* <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.VILLAGE_CITY}</h6>
                        {profileInfo.addressInfo &&
                          profileInfo.addressInfo
                            .correspondenceVillageCityId ? (
                          <span className="word-break">
                            {getVillage(
                              profileInfo.addressInfo
                                .correspondenceVillageCityId,
                              requiredVillage
                            )}
                          </span>
                        ) : (
                          <span className="word-break">
                            {profileInfo.addressInfo.correspondenceVillageCity}
                          </span>
                        )}
                      </div> */}
                      {/* <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.TALUKA}</h6>
                        {profileInfo.addressInfo &&
                          profileInfo.addressInfo.correspondenceTalukaId ? (
                          <span className="word-break">
                            {getTaluka(
                              profileInfo.addressInfo
                                .correspondenceTalukaId,
                              requiredTaluka
                            )}
                          </span>
                        ) : (
                          <span className="word-break">
                            {profileInfo.addressInfo.correspondenceTaluka}
                          </span>
                        )}
                      </div> */}
                      <div className="content-row clear-fix pb-1 pt-0">
                        <h6>{profileadressinformation.DISTRICT}</h6>
                        {profileInfo.addressInfo &&
                          profileInfo.addressInfo.correspondenceDistrictId ? (
                          <span className="word-break">
                            {getDistrict(
                              profileInfo.addressInfo
                                .correspondenceDistrictId,
                              requiredDistricts
                            )}
                          </span>
                        ) : (
                          <span className="word-break">
                            {profileInfo.addressInfo.correspondenceDistrict}
                          </span>
                        )}
                      </div>
                      <div className="content-row clear-fix pb-1 pt-0">
                        <div className="row">
                          <div className="col-md-8">
                            <h6>{profileadressinformation.STATE_UNION_TERRITORY}</h6>
                            <span>
                              {getStateName(
                                profileInfo.addressInfo.correspondenceStateId,
                                requiredStates
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="content-row clear-fix pb-1 pt-0">
                        <div className="col-md-4">
                          <h6>{profileadressinformation.PINCODE}</h6>
                          <span>{profileInfo.addressInfo.correspondencePin}</span>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              {/* other information */}

              <h6 className=" mt-2">
                {commonENLabels.NEW_APPLICATION.DETAILS_OF_COURT} :
                {commonHILabels.NEW_APPLICATION.DETAILS_OF_COURT}
              </h6>
              <div className="my-2 full-width-bottom-blue-border"></div>
              <div className="card">
                <div className="card-body pad_top_bottom_8">
                  <div className="card p-1">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              commonENLabels.OTHER_INFORMATION[
                              "WHETHER_ANY_PROSECUTION_IS_PENDING_IN_ANY_COURT_OF_LAW_AGAINST_YOU?"
                              ]
                            }
                            {
                              commonHILabels.OTHER_INFORMATION[
                              "WHETHER_ANY_PROSECUTION_IS_PENDING_IN_ANY_COURT_OF_LAW_AGAINST_YOU?"
                              ]
                            }
                          </h6>
                        </div>
                      </div>
                      <div className="col-md-1">
                        {profileInfo.otherInfo.isProsecutionPending
                          ? "Yes"
                          : "No"}
                      </div>
                    </div>
                  </div>
                  <div className="card p-1 mt-1">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              commonENLabels.OTHER_INFORMATION[
                              "WHETHER_DISCIPLINARY_OR_ANY_OTHER_SIMILAR_ACTION_IS_INITIATED_INSTITUTION?"
                              ]
                            }
                            {
                              commonHILabels.OTHER_INFORMATION[
                              "WHETHER_DISCIPLINARY_OR_ANY_OTHER_SIMILAR_ACTION_IS_INITIATED_INSTITUTION?"
                              ]
                            }
                          </h6>
                          {/* &ensp;
                                            <span>
                                                    {profileInfo.otherInfo
                                                        .flgDispActionGovSemiGov
                                                        ? "Yes"
                                                        : "No"}
                                                </span> */}
                        </div>
                      </div>
                      <div className="col-md-1">
                        {profileInfo.otherInfo.isDispActionByGovSemiGov
                          ? "Yes"
                          : "No"}
                      </div>
                    </div>
                  </div>
                  <div className="card p-1 mt-1">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              commonENLabels.OTHER_INFORMATION[
                              "WHETHER_ANY_DISCIPLINARY_ACTION_HAS_BEEN_INITIATED_BY_GOVERNMENT?"
                              ]
                            }
                            {
                              commonHILabels.OTHER_INFORMATION[
                              "WHETHER_ANY_DISCIPLINARY_ACTION_HAS_BEEN_INITIATED_BY_GOVERNMENT?"
                              ]
                            }
                          </h6>
                        </div>
                      </div>
                      <div className="col-md-1">
                        {profileInfo.otherInfo.isDispActionByBarcouncilInstitution
                          ? "Yes"
                          : "No"}
                      </div>
                    </div>
                  </div>
                  <div className="card p-1 mt-1">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              commonENLabels.OTHER_INFORMATION[
                              "WAS_ANY_COURT_CASE_FILED_AGAINST_YOU?"
                              ]
                            }
                            {
                              commonHILabels.OTHER_INFORMATION[
                              "WAS_ANY_COURT_CASE_FILED_AGAINST_YOU?"
                              ]
                            }
                          </h6>
                        </div>
                      </div>
                      <div className="col-md-1">
                        {profileInfo.otherInfo.isCourtCaseFiled ? "Yes" : "No"}
                      </div>
                    </div>
                  </div>
                  <div className="card p-1 mt-1">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              commonENLabels.OTHER_INFORMATION[
                              "WHETHER_DEBARRED_OR_BLACK_LISTED_FOR_EXAMINATION_OR_ANY_OTHER_ORGANISATIONS?"
                              ]
                            }
                            {
                              commonHILabels.OTHER_INFORMATION[
                              "WHETHER_DEBARRED_OR_BLACK_LISTED_FOR_EXAMINATION_OR_ANY_OTHER_ORGANISATIONS?"
                              ]
                            }
                          </h6>
                        </div>
                      </div>
                      <div className="col-md-1">
                        {profileInfo.otherInfo.isDebarredBlockListExam
                          ? "Yes"
                          : "No"}
                      </div>
                    </div>
                  </div>
                  {profileInfo.otherInfo.isDebarredBlockListExam ? (
                    <div className="card p-1 mt-1">
                      <div className="row">
                        <div className="col-md-10">
                          <div className="content-row clear-fix">
                            <h6>
                              {commonENLabels.OTHER_INFORMATION["DURATION"]}
                              {commonHILabels.OTHER_INFORMATION["DURATION"]}
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-2">
                          {profileInfo.otherInfo.dbrNatureLookupId === 1 ? (
                            <span>{profileDetailsLabel.PERMANENT}</span>
                          ) : profileInfo.otherInfo.dbrNatureLookupId === 2 ? (
                            <span>
                              {" "}
                              {profileDetailsLabel.FOR_CERTAIN_PERIOD}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {profileInfo.otherInfo.dbrNatureLookupId === 2 ? (
                    <div>
                      <hr className="mar_top_bottom_8" />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="content-row clear-fix">
                            <h6>{otherinformationLabel["FROM_DATE"]}</h6>
                            &ensp;
                            <span>
                              {profileInfo.otherInfo.dbrStartDate
                                ? dayjs(
                                  getFormattedDate(
                                    new Date(
                                      profileInfo.otherInfo.dbrStartDate
                                    )
                                  )
                                ).format(commonLabels.DATE_FORMAT)
                                : ""}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {profileInfo.otherInfo.isDebarredBlockListExam ? (
                            <div className="content-row clear-fix">
                              <h6>{otherinformationLabel["TO_DATE"]}</h6>
                              &ensp;
                              <span>
                                {profileInfo.otherInfo.dbrEndDate
                                  ? dayjs(
                                    getFormattedDate(
                                      new Date(
                                        profileInfo.otherInfo.dbrEndDate
                                      )
                                    )
                                  ).format(commonLabels.DATE_FORMAT)
                                  : ""}
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <h6 className=" mt-2">
                {commonENLabels.NEW_APPLICATION.PERTICULARS_OF_PRIZES} :
                {commonHILabels.NEW_APPLICATION.PERTICULARS_OF_PRIZES}
              </h6>
              <div className="my-2 full-width-bottom-blue-border"></div>
              <div className="card">
                <div className="card-body pad_top_bottom_8">
                  <div className="card p-1">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              commonENLabels.OTHER_INFORMATION
                                .OTHER_INFO_NOTE_3_2_1
                            }
                            {
                              commonHILabels.OTHER_INFORMATION
                                .OTHER_INFO_NOTE_3_2_1
                            }
                          </h6>
                          &ensp;
                        </div>
                      </div>
                      <div className="col-md-1">
                        <span>
                          {profileInfo.otherInfo.activities
                            ? profileInfo.otherInfo.activities
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* <hr className="mar_top_bottom_8" /> */}
                  <div className="card p-1">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              commonENLabels.OTHER_INFORMATION
                                .OTHER_INFO_NOTE_3_2_2
                            }
                            {
                              commonHILabels.OTHER_INFORMATION
                                .OTHER_INFO_NOTE_3_2_2
                            }
                          </h6>
                          &ensp;
                        </div>
                      </div>
                      <div className="col-md-1">
                        <span>
                          {profileInfo.otherInfo.distinctionLeadershipPosition
                            ? profileInfo.otherInfo.distinctionLeadershipPosition
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* <hr className="mar_top_bottom_8" /> */}
                  <div className="card p-1">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="content-row clear-fix">
                          <h6>
                            {
                              commonENLabels.OTHER_INFORMATION
                                .OTHER_INFO_NOTE_3_2_3
                            }
                            {
                              commonHILabels.OTHER_INFORMATION
                                .OTHER_INFO_NOTE_3_2_3
                            }
                          </h6>
                          &ensp;
                        </div>
                      </div>
                      <div className="col-md-1">
                        <span>
                          {profileInfo.otherInfo.extraCurricular
                            ? profileInfo.otherInfo.extraCurricular
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* qualification information */}
              <h6 className=" mt-2">
                {commonENLabels.NEW_APPLICATION.QUALIFICATION_INFORMATION}
                {commonHILabels.NEW_APPLICATION.QUALIFICATION_INFORMATION}
              </h6>
              <div className="my-2 full-width-bottom-blue-border"></div>
              <div className="qualification-table qualificationTableCss">
                <table className="table m-0 d-table">
                  <thead>
                    <tr>
                      {qualificationinformation.qualificationHeaderContentForAdvertisement &&
                        qualificationinformation.qualificationHeaderContentForAdvertisement
                          .slice(0, -2)
                          .map((ele, index) => (
                            <th
                              scope="col"
                              key={index}
                              className="theadBgColor blue_box"
                            >
                              {ele}
                            </th>
                          ))}
                    </tr>
                  </thead>
                  <tbody className="f12">
                    {profileInfo &&
                      profileInfo.qualificationInfoList
                        .sort((a, b) => {
                          return (
                            qualificationTypes.findIndex(
                              (type) =>
                                type.qualificationtypecode ===
                                a.qualificationtypecode
                            ) -
                            qualificationTypes.findIndex(
                              (type) =>
                                type.qualificationtypecode ===
                                b.qualificationtypecode
                            )
                          );
                        })
                        .map((ele, index) => {
                          if (
                            !ele.flgDeleted &&
                            ele.qualificationtypecode !== "Pb"
                          ) {
                            count++;
                            return (
                              <tr key={index}>
                                <td className="w-10 word-break text-center">
                                  {count}
                                </td>
                                <td className="word-break">
                                  {getQualificationType(
                                    ele.qualificationtypecode,
                                    requiredQualificationTypeCodes
                                  ) ? getQualificationType(
                                    ele.qualificationtypecode,
                                    requiredQualificationTypeCodes
                                  ) : "-"}
                                </td>
                                <td className="word-break">
                                  {getQualificationNameCode(
                                    ele.qualificationnamecode,
                                    requiredQualificationNameCode
                                  ) ? getQualificationNameCode(
                                    ele.qualificationnamecode,
                                    requiredQualificationNameCode
                                  ) : "-"}
                                </td>
                                <td className="word-break">
                                  {getSubject(
                                    ele.subjectLookupId,
                                    requiredSubject
                                  ) ? getSubject(
                                    ele.subjectLookupId,
                                    requiredSubject
                                  ) : "-"}
                                </td>

                                <td className="word-break">
                                  {getUniversity(
                                    ele.universitycode,
                                    requiredQualificationUniversityCodes
                                  ) ? getUniversity(
                                    ele.universitycode,
                                    requiredQualificationUniversityCodes
                                  ) : "-"}
                                </td>
                                <td className="word-break text-center">
                                  {ele.resultDate
                                    ? dayjs(
                                      getFormattedDate(new Date(ele.resultDate))
                                    ).format(commonLabels.DATE_FORMAT)
                                    : "-"}
                                </td>
                                <td className="word-break text-center">{ele.attempts || ele.attempts == 0 ? ele.attempts : "-"}</td>
                                <td className="word-break text-center">
                                  {ele.obtainedMarks || ele.obtainedMarks == 0 ? ele.obtainedMarks : "-"}
                                </td>
                                <td className="word-break text-center">
                                  {ele.totalMarks || ele.totalMarks == 0 ? ele.totalMarks : "-"}

                                </td>
                                <td className="word-break text-center">
                                  {ele.percentageGrade ?? ""}
                                  {/* {getLookupOptionLabelNew(
                                    ele.classGradeLookupId,
                                    profileCreationAllLookupData
                                  )} */}
                                </td>
                                <td className="word-break text-center">
                                  {ele.courseDurationMonths ?? ""}
                                </td>
                                <td className="word-break ">
                                  {getLookupOptionLabelNew(
                                    ele.classGradeLookupId,
                                    profileCreationAllLookupData
                                  ) ? getLookupOptionLabelNew(
                                    ele.classGradeLookupId,
                                    profileCreationAllLookupData
                                  ) : "-"}
                                </td>
                                <td className="word-break">
                                  {getLookupOptionLabelNew(
                                    ele.modeLookupId,
                                    profileCreationAllLookupData
                                  ) ? getLookupOptionLabelNew(
                                    ele.modeLookupId,
                                    profileCreationAllLookupData
                                  ) : "-"}
                                </td>
                                <td className="word-break">
                                  {/* {ele.compulsorySubjects} */}
                                  {getSubject(
                                    ele.compulsorySubjects,
                                    requiredSubject
                                  ) ? getSubject(
                                    ele.compulsorySubjects,
                                    requiredSubject
                                  ) : "-"}
                                </td>
                                <td className="word-break">
                                  {/* {ele.optionalSubjects} */}
                                  {getSubject(
                                    ele.optionalSubjects,
                                    requiredSubject
                                  ) ? getSubject(
                                    ele.optionalSubjects,
                                    requiredSubject
                                  ) : "-"}
                                </td>
                                <td className="word-break text-center">
                                  {ele.seatNumber ? ele.seatNumber : "-"}
                                </td>
                                <td className="word-break text-center">
                                  {ele.yearOfPassing ? ele.yearOfPassing : "-"}
                                </td>
                              </tr>
                            );
                          }
                        })}
                  </tbody>
                </table>
              </div>

              {showPublicationTable &&
                <>
                  <hr className="mb-0" />
                  <h6>
                    {qualificationinformation.PUBLICATION_DETAILS}
                  </h6>
                  <div className="qualification-table qualificationTableCss mt-1">
                    <table className="table table-bordered m-0 d-table">
                      <thead>
                        <tr>
                          {qualificationinformation.publicationQualificationHeaderContent && qualificationinformation.publicationQualificationHeaderContent.slice(0, -2).map((ele, index) =>
                            <th scope="col" key={index} className="theadBgColor blue_box">{ele}</th>
                          )}
                        </tr>
                      </thead>
                      <tbody className="f12">
                        {profileInfo && profileInfo.qualificationInfoList.sort((a, b) => {
                          return qualificationTypes.findIndex((type) => type.qualificationtypecode === a.qualificationtypecode)
                            - qualificationTypes.findIndex((type) => type.qualificationtypecode === b.qualificationtypecode);
                        }).map((ele, index) => {
                          if (!ele.flgDeleted && (ele.qualificationtypecode === "Pb")) {
                            publilcationTableCount++
                            return (
                              <tr key={index}>
                                <td className="w-10 word-break text-center">{publilcationTableCount}</td>
                                <td className="word-break ">{getQualificationType(ele.qualificationtypecode,
                                  requiredQualificationTypeCodes)}</td>
                                <td className="word-break ">{getQualificationNameCode(ele.qualificationnamecode,
                                  requiredQualificationNameCode)}</td>
                                <td className="word-break">{ele && ele.indexingBodyLookupId && nameOfIndexingBodies((ele.indexingBodyLookupId), nameOfIndexingBodiesList)}</td>
                                <td className="word-break">{ele && ele.articleTypeLookupId && articleType((ele.articleTypeLookupId), getPublicationArticleTypeList)}</td>
                                <td className="word-break">{ele && flgPublicationFirstAuthor(((ele.isPublicationFirstAuthor === true) || (ele.isPublicationFirstAuthor === "true") ? true : (ele.isPublicationFirstAuthor === false) || (ele.isPublicationFirstAuthor === "false") ? false : ""), BOOLEAN_OPTION)}</td>
                                <td className="word-break">{ele && ele.publicationAuthorType && authorType((ele.publicationAuthorType), AUTHOR_TYPES)}</td>
                                <td className="word-break">{ele && ele.publicationJournalDetails}</td>
                                <td> {ele.publicationIssnNo ? ele.publicationIssnNo : "-"} </td>
                                <td className="word-break">{ele && ele.publicationYear}</td>
                                <td className="word-break">{ele && ((ele.isImpactIndex20OrMore === true || ele.isImpactIndex20OrMore === "true") ? "Yes" : (ele.isImpactIndex20OrMore === false || ele.isImpactIndex20OrMore === "false") ? "No" : "")}</td>
                                <td className="word-break">{ele && ele.publicationPaperTitle}</td>
                                <td className="word-break">{ele && ele.publicationAcceptanceDate && dayjs(getFormattedDate(ele.publicationAcceptanceDate)).format(commonLabels.DATE_FORMAT)}</td>
                                <td className="word-break">{ele && ele.publicationPublishedDate && dayjs(getFormattedDate(ele.publicationPublishedDate)).format(commonLabels.DATE_FORMAT)}</td>
                                <td className="word-break">
                                  {ele.isPublicationGuide && ele.isPublicationGuide ? "Yes" : "No"}
                                </td>
                                {/*<td className="word-break">
                                  {ele.yearOfPassing}
                                </td> */}
                              </tr>
                            )
                          }
                        })
                        }
                      </tbody>
                    </table>
                  </div>
                </>}

              {showInternshipTable && (
                <>
                  <h6 className="bottom-dotted-line align-left p-1 mt-2">
                    {qualificationinformation.INTERNSHIP_DETAILS}{" "}
                    {qualificationinformation_hindi.INTERNSHIP_DETAILS_hin}
                  </h6>
                  <br />
                  <table className="table table-bordered mb-4 ">
                    <thead>
                      <tr className="qualifcation_table">
                        {qualificationinformation.internshipAdvertisementHeaderContent?.map(
                          (ele, index) => (
                            <th
                              className="theadBgColor theadBgColor_qualification text-left"
                              scope="col"
                              key={index}
                            >
                              {ele}
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody className="f12">
                      {internshipList?.map((ele, index) => {
                        if (!ele.isDelete) {
                          internshipCount++;
                          return (
                            <tr key={index}>
                              <td className=" word-break text-center">{internshipCount}</td>
                              <td className="word-break ">{ele
                                ? ele
                                  .subject
                                : "-"}</td>

                              <td className="word-break ">{ele ? ele.qualificationname
                                : "-"}</td>
                              <td className="word-break ">
                                {ele?.internshipFromDate ? dayjs(getFormattedDate(ele.internshipFromDate)).format(commonLabels.DATE_FORMAT) : "-"}
                              </td>
                              <td className="word-break ">
                                {ele?.internshipToDate ? dayjs(getFormattedDate(ele.internshipToDate)).format(commonLabels.DATE_FORMAT) : "-"}
                              </td>
                              <td className="word-break text-left w-20 text-uppercase">{ele?.internshipCollege ?? "-"}</td>
                              <td className="word-break text-uppercase">{ele?.internshipCertificate ?? "-"}</td>
                              <td className="word-break ">
                                {ele?.internshipIssueDate ? dayjs(getFormattedDate(ele.internshipIssueDate)).format(commonLabels.DATE_FORMAT) : "-"}
                              </td>
                              <td className="word-break w-15 text-uppercase">{ele?.internshipIssuedBy ?? "-"}</td>
                            </tr>
                          );
                        }
                      })}

                    </tbody>
                  </table>
                </>
              )}

              {/* experience information */}

              <h6 className=" mt-2">
                {commonENLabels.NEW_APPLICATION.EXPERIENCE_DETAILS}
                {commonHILabels.NEW_APPLICATION.EXPERIENCE_DETAILS}
              </h6>
              <div className="my-2 full-width-bottom-blue-border"></div>
              <div></div>
              {profileInfo && profileInfo.isExperienced ? (
                <div className="qualification-table qualificationTableCss">
                  <table className="table table-bordered m-0 d-table">
                    <thead>
                      <tr>
                        {experienceinformation.experienceHeaderContent
                          .slice(0, -2)
                          .map((ele, index) => (
                            <th
                              scope="col"
                              key={index}
                              className="theadBgColor blue_box"
                            >
                              {ele}
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody className="f12">
                      {profileInfo &&
                        profileInfo.experienceInfoList.map((ele, index) => {
                          if (!ele.flgDeleted) {
                            return (
                              <tr key={index}>
                                <td className="w-10 word-break text-center">
                                  {index + 1}
                                </td>
                                <td className="word-break">{ele.officeName.toUpperCase()}</td>
                                <td className="word-break">{ele.designation}</td>
                                <td className="word-break">
                                  {getLookupOptionLabelNew(
                                    ele.apointmentNatureLookupId,
                                    profileCreationAllLookupData
                                  )}
                                </td>
                                <td className="word-break">
                                  {getLookupOptionLabelNew(
                                    ele.jobNatureLookupId,
                                    profileCreationAllLookupData
                                  )}
                                </td>
                                <td className="word-break">
                                  {getDropdownOptionLabel(
                                    ele.fullTimeLookupId,
                                    FULLTIME_OPTION
                                  )}
                                </td>
                                <td className="word-break">{ele.payScale}</td>
                                <td className="word-break">{ele.gradePay}</td>
                                <td className="word-break">
                                  {ele.monthlyGrossSalary}
                                </td>
                                <td className="word-break">
                                  {ele.employmentFrom
                                    ? dayjs(
                                      getFormattedDate(new Date(ele.employmentFrom))
                                    ).format(commonLabels.DATE_FORMAT)
                                    : ""}
                                </td>
                                {ele.employmentTo && (
                                  <td className="word-break">
                                    {ele.employmentTo
                                      ? dayjs(
                                        getFormattedDate(new Date(ele.employmentTo))
                                      ).format(commonLabels.DATE_FORMAT)
                                      : dayjs().format(commonLabels.DATE_FORMAT)}
                                  </td>
                                )}
                                {ele.employmentTo && (
                                  <td className="word-break">
                                    {ele.employmentTo
                                      ? ele.expYears
                                      : handleFromToDateSelectionForExp(
                                        dayjs(
                                          getFormattedDate(
                                            new Date(ele.employmentFrom)
                                          )
                                        ).format(),
                                        dayjs().format()
                                      ).expYears}
                                  </td>
                                )}
                                {ele.employmentTo && (
                                  <td className="word-break">
                                    {ele.employmentTo
                                      ? ele.expMonths
                                      : handleFromToDateSelectionForExp(
                                        dayjs(
                                          getFormattedDate(
                                            new Date(ele.employmentFrom)
                                          )
                                        ).format(),
                                        dayjs().format()
                                      ).expMonths}
                                  </td>
                                )}
                                {ele.employmentTo && (
                                  <td className="word-break">
                                    {ele.employmentTo
                                      ? ele.expDays
                                      : handleFromToDateSelectionForExp(
                                        dayjs(
                                          getFormattedDate(
                                            new Date(ele.employmentFrom)
                                          )
                                        ).format(),
                                        dayjs().format()
                                      ).expDays}
                                  </td>
                                )}
                                <td className="word-break">
                                  {getLookupOptionLabelNew(
                                    ele.institutionLookupId,
                                    profileCreationAllLookupData
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="card">
                  <div className="card-body pad_top_bottom_8">
                    <div className="content-row clear-fix">
                      <h6>{experienceinformation.ARE_YOU_HAVING_EXPERIENCE}</h6>
                      &ensp;
                      <span>
                        {profileInfo && profileInfo.isExperienced ? "Yes" : "No"}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              <hr className="mt-2 mb-0" />
              {eligibilityResultList != null &&
                applicationPostPrefList?.length != 0 &&
                applicableAdditionalQuestionsList &&
                applicableAdditionalQuestionsList?.length != 0 && (
                  <div className="box-contents mt-1 pt-0">
                    <h5>
                      {advertisementDetailsLabel.QUESTIONS}
                    </h5>
                    <div className="my-2 full-width-bottom-blue-border mt-2"></div>

                    <QuestionDetails
                      additionalAnswers={additionalAnswers}
                      additionalAnswersState={additionalAnswersState}
                      handleQuestions={handleQuestions}
                      isNext={isNext}
                      applicationFee={applicationFee}
                      applicationFeeWithoutConcession={applicationFeeWithoutConcession}
                    />
                  </div>
                )}

              {/* {((profileInfo !== null) && (advertisementDetailsInfo)) && */}
              {((profileInfo !== null) && (eligibilityResultList != null)) &&
                <div className="box-contents mt-2 pt-0">
                  <h6>
                    {commonENLabels.NEW_APPLICATION.POST +
                      " " +
                      commonHILabels.NEW_APPLICATION.POST}
                  </h6>
                  <div className="my-2 full-width-bottom-blue-border"></div>
                  {eligibilityResultList?.map((examPost) => (
                    <div key={examPost.postCriteriaId} className="card mt-2">
                      <div className="card-header post-card-head">
                        <div className="row">
                          <div className="col-md-6">
                            <span>{examPost?.postName}</span>
                            <div>({examPost?.nameDvng})</div>
                          </div>
                          <div className="col-md-6">
                            {getElibilityIndicator(examPost.postCriteriaId)}
                          </div>
                        </div>
                      </div>
                      <div className="card-body pre-wrap">
                        {examPost?.description}
                      </div>

                      {/* weightage section */}
                      {(examPost && examPost.isEligible && examPost.weightageDto) &&
                        <>
                          <hr className="mt-2 mb-0" />
                          <h6 className="mt-2 ms-2">
                            {commonENLabels.PERSONAL_INFORMATION.POSTS_WEIGHTAGE}
                          </h6>
                          <div className="my-2 full-width-bottom-blue-border ms-2 me-2"></div>
                          <div className="row m-2">
                            <div className="col-md-6">
                              <div className="card">
                                <div className="card-header blue_box pb-1 pt-1">
                                  <span>{commonENLabels.PERSONAL_INFORMATION.QUALIFICATIONS_WEIGHTAGE}</span>
                                  {/* <span className="float-end">{commonENLabels.PERSONAL_INFORMATION.MAX_WEIGHTAGE} : {examPost && examPost.weightageDto && examPost.weightageDto.qualifications && examPost.weightageDto.qualifications.maxWeightage ? examPost.weightageDto.qualifications.maxWeightage : ''}</span> */}
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                  <div className="qualification-table qualificationTableCss">
                                    <table className="table m-0 d-table">
                                      <thead>
                                        <tr>
                                          {commonENLabels.QUALIFICATION_WEIGHTAGE_HEADER_CONTENT &&
                                            commonENLabels.QUALIFICATION_WEIGHTAGE_HEADER_CONTENT
                                              .map((ele, index) => (
                                                <th
                                                  scope="col"
                                                  key={index}
                                                  className="theadBgColor blue_box text-center"
                                                >
                                                  {ele}
                                                </th>
                                              ))}
                                        </tr>
                                      </thead>
                                      <tbody className="f12">
                                        {examPost && examPost.weightageDto && examPost.weightageDto.qualifications && examPost.weightageDto.qualifications.qualificationList && examPost.weightageDto.qualifications.qualificationList.length > 0 ? examPost.weightageDto.qualifications.qualificationList
                                          .map((ele, index) => {
                                            return (
                                              <tr key={index}>
                                                <td className="w-10 word-break text-center">
                                                  {index + 1}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.qualificationTypeCode}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.qualificationName}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.weightage}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.maxWeightage}
                                                </td>
                                              </tr>
                                            );
                                          })
                                          :
                                          <tr>
                                            <td colSpan="4" className="text-center">{commonENLabels.NEW_APPLICATION.NO_RECORD_FOUND}</td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="card">
                                <div className="card-header blue_box pb-1 pt-1">
                                  <span>{commonENLabels.PERSONAL_INFORMATION.EXPERIENCE_WEIGHTAGE}</span>
                                  {/* <span className="float-end">{commonENLabels.PERSONAL_INFORMATION.MAX_WEIGHTAGE} : {examPost && examPost.weightageDto && examPost.weightageDto.qualifications && examPost.weightageDto.experience.maxWeightage ? examPost.weightageDto.experience.maxWeightage : ''}</span> */}
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                  <div className="qualification-table qualificationTableCss">
                                    <table className="table m-0 d-table">
                                      <thead>
                                        <tr>
                                          {commonENLabels.EXPERIENCE_WEIGHTAGE_HEADER_CONTENT &&
                                            commonENLabels.EXPERIENCE_WEIGHTAGE_HEADER_CONTENT
                                              .map((ele, index) => (
                                                <th
                                                  scope="col"
                                                  key={index}
                                                  className="theadBgColor blue_box text-center"
                                                >
                                                  {ele}
                                                </th>
                                              ))}
                                        </tr>
                                      </thead>
                                      <tbody className="f12">
                                        {examPost && examPost.weightageDto && examPost.weightageDto.experience && examPost.weightageDto.experience.experienceList && examPost.weightageDto.experience.experienceList.length > 0 ? examPost.weightageDto.experience.experienceList
                                          .map((ele, index) => {
                                            return (
                                              <tr key={index}>
                                                <td className="w-10 word-break text-center">
                                                  {index + 1}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.designation}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.apointmentNature}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.jobNature}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.experienceByYear}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.weightage}
                                                </td>
                                                <td className="word-break text-center">
                                                  {ele.maxWeightage}
                                                </td>
                                              </tr>
                                            );
                                          })
                                          :
                                          <tr>
                                            <td colSpan="4" className="text-center">{commonENLabels.NEW_APPLICATION.NO_RECORD_FOUND}</td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                    </div>
                  ))}
                </div>
              }
              {eligibilityResultList != null &&
                applicationPostPrefList?.length != 0 && (
                  <>
                    <div className="card f11 tab_container_box mt-2">
                      <div className="card-header border_btm_blue9">
                        <span className="fw-bold text_black">
                          {showPreferences ? commonENLabels.NEW_APPLICATION.Select_and_apply : commonENLabels.NEW_APPLICATION.Select_and_apply_Without_Preference}
                        </span>
                        <span className="fw-bold text_black pull-right">
                          {showPreferences && commonENLabels.NEW_APPLICATION.Preferences}
                        </span>

                      </div>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <span>
                            {advertisementDetailsLabel.EligibleFollowingPost}
                          </span>
                        </li>
                        {applicationPostPrefList?.map((postPref, index) => (
                          <div key={index}>

                            <li
                              className={`list-group-item post-pref-item d-flex ${index == applicationPostPrefList.length - 1 &&
                                "border_bottom_10"
                                }`}
                            >
                              <span>{index + 1}.</span>
                              <div className="flex-grow-1 ms-4">
                                <input
                                  className="d-inline-block"
                                  type="checkbox"
                                  name="isInterested"
                                  checked={postPref.isInterested}
                                  onChange={(event) =>
                                    handlePrefChange(
                                      postPref,
                                      "isInterested",
                                      event.target.checked,
                                      postPref.postCriteriaId
                                    )
                                  }
                                  disabled={isNext}
                                />{" "}
                                &nbsp;
                                <span>
                                  {getPostName(postPref.postCriteriaId)}
                                </span>{" "}
                                <br /> &nbsp; &nbsp; &nbsp;
                                <span className="w65">
                                  {getPostName(postPref.postCriteriaId, true)}
                                </span>
                              </div>
                              <div className="arrange-arrows d-flex flex-column justify-content-between">
                                <div>
                                  {index > 0 && (
                                    <i
                                      className="fa fa-arrow-up"
                                      onClick={() => movePostPrefUp(index)}
                                      mtitle="Move Up"
                                    ></i>
                                  )}
                                </div>
                                <div>
                                  {index < applicationPostPrefList.length - 1 && (
                                    <i
                                      className="fa fa-arrow-down"
                                      onClick={() => movePostPrefDown(index)}
                                      title="Move Down"
                                    ></i>
                                  )}
                                </div>
                              </div>
                            </li>
                            {postPref.isInterested === true &&
                              postPref.isAssignAuthority === true &&
                              (
                                <div className="card-body">
                                  <div className="pad_0 btn-dropdown">
                                    <Select
                                      isMulti={true}
                                      closeMenuOnSelect={false}
                                      hideSelectedOptions={false}
                                      openMenuOnClick={handleMenuClick()}
                                      placeholder={
                                        advertisementDetailsLabel.APPOINTING_AUTHORITIES
                                      }
                                      onChange={(options) => {
                                        handleOptionsChange(
                                          options,
                                          postPref.postCriteriaId
                                        );
                                      }}
                                      formatGroupLabel={formatGroupLabel}
                                      options={[
                                        {
                                          label:
                                            advertisementDetailsLabel.MUMBAI_APPOINTING_AUTHORITIES,
                                          options: deptOptions
                                            .filter(
                                              (ele) =>
                                                ele.pid == postPref.postCriteriaId
                                            )
                                            .map((elem) => elem.options.mumbai)[0],
                                        },
                                        {
                                          label:
                                            advertisementDetailsLabel.OTHER_THAN_MUMBAI_APPOINTING_AUTHORITIES,
                                          options: deptOptions
                                            .filter(
                                              (ele) =>
                                                ele.pid == postPref.postCriteriaId
                                            )
                                            .map(
                                              (elem) => elem.options.outsideMumbai
                                            )[0],
                                        },
                                      ]}
                                      controlShouldRenderValue={false}
                                      isOptionDisabled={(option) =>
                                        option.isDisable
                                      }
                                      components={{
                                        Option: InputOption,
                                      }}
                                    />
                                    {someOptionsThisPost &&
                                      someOptionsThisPost.indexOf(
                                        postPref.postCriteriaId
                                      ) == -1 ? (
                                      <p className="errorText">
                                        {
                                          advertisementDetailsLabel.PLEASE_SELECT_APPOINTING_AUTHORITY
                                        }
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <button
                                    type="button"
                                    className=" btn btn-primary custom_button  btn-bg-cust button_reset_apply review_btn_css  "
                                    onClick={() =>
                                      showReviewDepartmentModal(
                                        postPref.postCriteriaId
                                      )
                                    }
                                  >
                                    {
                                      advertisementDetailsLabel.REVIEW_SELECTED_APPOINTING_AUTHORITIES
                                    }
                                  </button>
                                  &nbsp;
                                </div>
                              )}
                          </div>
                        ))}
                      </ul>
                    </div>
                  </>
                )}

              {/* {eligibilityResultList != null &&
                applicationPostPrefList?.length == 0 && (
                  <div className="card f11 tab_container_box  mt-2">
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item">
                        <span>
                          {
                            advertisementDetailsLabel.YouAreNotEligiblePost
                          }
                        </span>
                      </li>
                    </ul>
                  </div>
                )} */}

              {eligibilityResultList != null &&
                applicationPostPrefList?.length != 0 &&
                !isNext && (
                  <div className="col-md-2">
                    <button
                      type="button"
                      className="btn btn-outline-dark button_reset_apply"
                      onClick={resetPref}
                    >
                      {common.RESET}
                    </button>
                    <button
                      type="button"
                      className=" btn btn-primary custom_button  btn-bg-cust btn button_reset_apply  "
                      disabled={(!hasAtLeastOneInterested)}
                      onClick={doNext}
                    >
                      {common.APPLY}
                    </button>
                  </div>
                )}

              {isNext && (
                <>
                  {uploadedDocumentData && uploadedDocumentData.length > 0 ? (
                    <div className="card f11 tab_container_box mt-2">
                      <div className="card-header border_btm_blue9 pe-0">
                        <span className="fw-bold">
                          {advertisementDetailsLabel.Upload_select_documents}{" "}
                          <span className="redColor">*</span>
                        </span>
                      </div>
                      <span className="noteColor ps-2">
                        {advertisementDetailsLabel.CONFIRM_UPLOAD_DOCUMENT_NOTE}{" "}
                      </span>
                      <span className="redColor ps-2">
                        {commonENLabels.COMMON.FILE_SIZE_150_KB_ERR_MES}
                      </span>
                      <div className="card-body">
                        <div className="pad_0">
                          {uploadedDocumentData && (
                            <div className="row">
                              {uploadedDocumentData.map((doc, i) => (
                                <div key={i} className="col-md-6">
                                  <ul key={i} className="list-group mb-1">
                                    <li
                                      className={`list-group-item post-pref-item d-flex ${i == uploadedDocumentData.length - 1 &&
                                        "border_bottom_10"
                                        }`}
                                    >
                                      <div className="flex-grow-1">
                                        <input
                                          className="d-inline-block me-1"
                                          type="checkbox"
                                          name="isUploaded"
                                          checked={doc.isUploaded}
                                          onChange={(event) =>
                                            handleDocChange(
                                              doc,
                                              "isUploaded",
                                              event.target.checked
                                            )
                                          }
                                          disabled={!doc.documentInfoId}
                                        />
                                        &nbsp;
                                        <i
                                          className="fa fa-info-circle document_list_css"
                                          data-toggle="tooltip"
                                          title="Document List"
                                          aria-hidden="true"
                                          onClick={() =>
                                            handleDocumentListShow(
                                              doc.documentTypeDescription
                                            )
                                          }
                                        ></i>
                                        <span>{doc.documentTypeName}</span>
                                        <div className="float-end">
                                          <input
                                            type="file"
                                            name="document"
                                            id={"document" + i}
                                            onChange={(event) =>
                                              onChangeDocument(event, doc)
                                            }
                                            className="d-none"
                                            accept="application/pdf"
                                          />
                                          {doc.documentInfoId ? (
                                            <label
                                              htmlFor={"document" + i}
                                              className="pointer-class"
                                            >
                                              {advertisementDetailsLabel.RE_UPLOAD}
                                            </label>
                                          ) : (
                                            <label
                                              htmlFor={"document" + i}
                                              className="pointer-class"
                                            >
                                              {advertisementDetailsLabel.UPLOAD}
                                            </label>
                                          )}
                                        </div>
                                        <div>
                                          {doc.documentInfoId ? (
                                            <button
                                              type="button"
                                              className="pointer-class"
                                              onClick={() => viewDocument(doc)}
                                            >
                                              {
                                                advertisementDetailsLabel.VIEW_UPLOADED_DOCUMENT
                                              }
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              className="text-danger ms37"
                                            >
                                              {advertisementDetailsLabel.NOT_UPLOADED}
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {isCenterSelection && <div className="card tab_container_box mt-2">
                    <div className="card-header border_btm_blue9">
                      <span className="fw-bold">
                        {advertisementDetailsLabel.Select_exam_center}{" "}
                        <span className="redColor">*</span>
                      </span>
                    </div>
                    {maxCenterSelectionNumber ? (
                      <span className="noteColor p-2">
                        {" "}
                        {advertisementDetailsLabel.SELECT_NOTE} {maxCenterSelectionNumber}{" "}
                        {advertisementDetailsLabel.EXAM_CENTER}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                    <div className="card-body">
                      <div className="pad_0 btn-dropdown">
                        <Select
                          isMulti={true}
                          // isOptionDisabled={() =>
                          //   maximumNoCenter
                          //     ? selectedExamCenters.length >= maximumNoCenter
                          //     : false
                          // }
                          isOptionDisabled={() =>
                            maxCenterSelectionNumber
                              ? selectedExamCenters.length >= maxCenterSelectionNumber
                              : false
                          }
                          value={selectedExamCenters}
                          onChange={setSelectedExamCenters}
                          options={examCenterOptionList.filter(
                            (examCenter) => examCenter.isDeleted == false
                          )}
                        />
                        {selectedExamCenters && selectedExamCenters.length >= 1 ? (
                          ""
                        ) : (
                          <p className="errorText">
                            {advertisementDetailsLabel.SELECT_OPTIONS}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>}

                  {(isApplicationLivePhotoEnable && (uploadedDocumentData && uploadedDocumentData.length > 0)) &&
                    <div className="row">
                      <div className="col-md-3 offset-5 mt-2 ">
                        <span className="pe-2 pt-4 mt-2 ms-2 fw-bold float-left">
                          {profileuploadphotosignature.LIVE_PHOTO}&nbsp;
                          <span className="redColor">*</span>

                        </span>
                        <div className="imageContainer float-left ">
                          <div className="imageSection" >

                            {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ? <span className="removeCandidateImage" title={profileuploadphotosignature.REMOVE_PHOTO} onClick={removeCandidateLiveImage}>X</span> : ''}
                            {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ?
                              <img src={(uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) ? `${uploadLiveImage.showCandidatePhoto}` : `data:image/png;base64, ${uploadLiveImage.showCandidatePhotoBase64}`} width="145" height="120" alt="" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CANDIDATE_PHOTO} /> :
                              ""}
                            {showName ?
                              (<div>
                                {/* Webcam Modal */}
                                <Modal show={showName} onHide={hideModal} size="s" backdrop="static" centered>
                                  <Modal.Header className="custom-modal-header logout_heading">
                                    <Modal.Title className="logout_title">
                                    {commonLabels.Live_Photo_Capture}
                                    </Modal.Title>
                                    <button
                                      type="button"
                                      className="ms-auto logout_close"
                                      aria-label="Close"
                                      onClick={hideModal}
                                    >X</button>
                                  </Modal.Header>

                                  <Modal.Body className="d-flex flex-column align-items-center">
                                    {/* Webcam Preview */}
                                    <div className="pb-3">

                                      <p className="text-center h3" >Hi , <span className="text-primary">{profileSummaryInfo.englishFullName} </span> <br /> Are you ready for live photo ?</p>
                                      <br />
                                      <p className='text-center h4 error'> <span className='text-danger h1 text-center'> {timer}</span>  seconds to go</p>
                                    </div>

                                
                                  </Modal.Body>
                                </Modal>
                              </div>) :
                              <div className="pb36">
                                {/* <ImageCropper /> */}
                              </div>
                            }
                            {isCameraOn ?
                              <div>
                                <Modal show={isCameraOn} onHide={hideModal} size="s" backdrop="static" centered>
                                  <Modal.Header className="custom-modal-header logout_heading">
                                    <Modal.Title className="logout_title">{commonLabels.Live_Photo_Capture}</Modal.Title>
                                    <button
                                      type="button"
                                      className="ms-auto logout_close"
                                      aria-label="Close"
                                      onClick={() => { hideModal(); }}
                                    >X</button>
                                  </Modal.Header>

                                  <Modal.Body className="d-flex flex-column align-items-center">
                                    {/* Webcam Preview */}
                                    <div className="pb-3">
                                      <Webcam
                                        audio={false}
                                        ref={webcamRef}
                                        screenshotFormat="image/jpeg"
                                        className="w-100 h-100 rounded shadow"
                                      />
                                    </div>

                                  
                                  </Modal.Body>
                                  <Modal.Footer>
                                                    <button type="button" className="btn btn-primary" onClick={capture}>{commonLabels.SET_IMAGE}</button>
                                               <Button type="button" className="btn btn-secondary" onClick={() => { hideModal(); }}>{commonLabels.CANCEL}</Button>
                                                </Modal.Footer>
                                </Modal>
                              </div>
                              :
                              <div className="pb36">
                                {/* <ImageCropper /> */}
                              </div>
                            }
                            {(errorLivePhoto != "" && (uploadLiveImage.showCandidatePhoto == "" || uploadLiveImage.showCandidatePhoto.length == null || uploadLiveImage.showCandidatePhoto.length == "") && uploadLiveImage.showCandidatePhotoBase64 == "") ? <span className='errorMsg'>{errorLivePhoto}</span> : ''}
                            <button className=' btn btn-primary custom_button  mt-3 livePhotoBtn text-blue  ' onClick={popupName} >{profileuploadphotosignature.LIVE_PHOTO} <i className="fa fa-camera fa-lg m-1" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CAMERA}></i></button><br />
                            {/* {((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) ? <button className=' btn btn-primary custom_button  mt-1 livePhotoBtn text-blue' onClick={showLiveImageCropper}>{profileuploadphotosignature.LIVE_PHOTO_CROP} <i className="fa fa-crop fa-lg m-1"  aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title={profileuploadphotosignature.CROP_PHOTO}></i> </button> : ''}  */}
                          </div>
                          {showSuccessLivePhotoModal ?
                            (<div>
                              {/* Webcam Modal */}
                              <Modal show={showSuccessLivePhotoModal} onHide={hideModal} size="s" backdrop="static" centered>
                                <Modal.Header className="custom-modal-header logout_heading">
                                  <Modal.Title className="logout_title">
                                    {commonLabels.Live_Photo_Capture_SuccessFully}
                                  </Modal.Title>
                                  <button
                                    type="button"
                                    className="ms-auto logout_close"
                                    aria-label="Close"
                                    onClick={hideModal}
                                  >X</button>
                                </Modal.Header>

                                <Modal.Body className="d-flex flex-column align-items-center">
                                  {/* Webcam Preview */}
                                  <div className="pb-3">
                                    <p className="text-center h4" >{commonLabels.Thank_You}, <span className="text-primary">{profileSummaryInfo.englishFullName} </span> <br /> Your live photo has been captured.</p>
                                  </div>

                                 
                                </Modal.Body>
                                 <Modal.Footer>
                                                    <button type="button" className="btn btn-secondary" onClick={() => setShowSuccessLivePhotoModal(false)}>{commonLabels.OK}</button>
                                                </Modal.Footer>
                              </Modal>
                            </div>) :
                            <div className="pb36">
                              {/* <ImageCropper /> */}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  {(profileInfo !== null && (uploadedDocumentData && uploadedDocumentData.length > 0)) && (
                    <div className="box-contents">
                      <h6 className="mt-2">
                        {commonENLabels.NEW_APPLICATION.Declaration}
                        {commonHILabels.NEW_APPLICATION.Declaration}
                      </h6>
                      <div className="my-2 full-width-bottom-blue-border"></div>
                      <div className="row">
                        {allDeclAccepted !== undefined &&
                          <div className="col-md-1">
                            <input
                              type="checkbox"
                              className="ms-4 mt-2 large-checkbox"
                              checked={allDeclAccepted}
                              onChange={(event) => {
                                setAllDeclAccepted(event.target.checked),
                                  SetIsCheckboxMarked(event.target.checked);
                              }
                              }
                            />
                            &nbsp;&nbsp;
                            <label className="fs-6">I Agree</label>
                          </div>
                        }

                        <div className="col-md-11 f11">
                          <div>
                            <span className="font-weight-bold">
                              {commonENLabels.COMMON.DECLARATION_LINE_1}{" "}
                            </span><br />
                            <span className="font-color-blue">
                              {commonHILabels.COMMON.DECLARATION_LINE_1}{" "}
                            </span>
                          </div>
                          <div className="mt-2">
                            <span className="font-weight-bold">
                              {commonENLabels.COMMON.DECLARATION_LINE_2}{" "}
                            </span><br />
                            <span className="font-color-blue">
                              {commonHILabels.COMMON.DECLARATION_LINE_2}{" "}
                            </span>
                          </div>
                          <div className="mt-2">
                            <span className="font-weight-bold">
                              {commonENLabels.COMMON.DECLARATION_LINE_3}{" "}
                            </span><br />
                            <span className="font-color-blue">
                              {commonHILabels.COMMON.DECLARATION_LINE_3}{" "}
                            </span>
                          </div>
                          <div className="mt-2">
                            <span className="font-weight-bold">
                              {commonENLabels.COMMON.DECLARATION_LINE_4}{" "}
                            </span><br />
                            <span className="font-color-blue">
                              {commonHILabels.COMMON.DECLARATION_LINE_4}{" "}
                            </span>
                          </div>
                          <div className="fw-bold">
                            {advertisementDetailsLabel.DATE}{" "}
                            {dayjs().format(commonLabels.DATE_FORMAT)}
                          </div>
                          <div className="row">
                            <div className="col-md-2 d-flex text-left flex-column">
                              <span className="pe-2 fw-bold">
                                {advertisementDetailsLabel.Location}&nbsp;
                                <span className="redColor">*</span>
                              </span><br />
                              <div className="input-group bg-color">
                                <input
                                  type="text"
                                  className="form-control text"
                                  placeholder="Enter current location"
                                  value={location}
                                  onChange={(event) => setLocation(event.target.value)}
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mt-2 d-flex flex-column">
                              <h6>{advertisementDetailsLabel.CANDIDATE_SIGNATURE_EN}</h6>
                              <img
                                src={
                                  profileInfo && profileInfo.signature
                                    ? `data:image/png;base64,${profileInfo.signature}`
                                    : ""
                                }
                                width="130"
                                height="60"
                              />
                            </div>
                            <div className="col-md-3 mt-2 d-flex flex-column">
                              <h6>{advertisementDetailsLabel.CANDIDATE_SIGNATURE_HI}</h6>
                              <img
                                src={
                                  profileInfo && profileInfo.hinSignature
                                    ? `data:image/png;base64,${profileInfo.hinSignature}`
                                    : ""
                                }
                                width="130"
                                height="60"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 ms-2">
                            <button
                              type="button"
                              className="btn btn-outline-dark btn-sm button_reset_apply"
                              onClick={goBack}
                            >
                              {common.CANCEL}
                            </button>
                            <button
                              type="button"
                              className=" btn btn-primary custom_button  btn-bg-cust btn-sm button_reset_apply  "
                              onClick={handleApply}
                            // disabled={
                            //   (!isCheckboxMarked || isApplicationLivePhotoEnable ? !(
                            //     // declAccepted &&
                            //     allDeclAccepted &&
                            //     location &&
                            //     ((uploadLiveImage.showCandidatePhoto !== "" && uploadLiveImage.showCandidatePhoto.length > 0) || (uploadLiveImage.showCandidatePhotoBase64 !== "" && uploadLiveImage.showCandidatePhotoBase64 !== null)) &&
                            //     allAnswersFilled &&
                            //     // selectedExamCenters.length > 0 &&
                            //     (!(isCenterSelection && selectedExamCenters.length <= maxCenterSelectionNumber)) &&
                            //     selectedOptionErr
                            //   ) : false)

                            // }
                            >
                              {common.SUBMIT_AND_FEES}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default ProfileDetails;
